import React, { useState, Fragment } from "react";

import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import PencilOutline from "mdi-material-ui/PencilOutline";
import DeleteOutline from "mdi-material-ui/DeleteOutline";
import _ from "lodash";
import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import DialogModal from "@core/components/dialogmodal";
import { isPermissionAllow } from "@core/utils/IsPermissionAllow";
import moment from "moment";

const FeedbackTypeList = (props) => {
  const {
    handleDeleteModal,
    deleteOpen,
    handleOpen,
    feedbackTypeList,
    pageSize,
    searchText,
    pageNumber,
    setPageSize,
    setSearchText,
    setPageNumber,
    totalRecord,
    role,
    permission,
  } = props;

  const [deleteId, setDeleteId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleEdit = (id) => {
    handleOpen("edit", id);
  };

  const handleDelete = (id) => {
    handleDeleteModal();
    setDeleteId(id);
  };

  const columns = [
    {
      flex: 0.3,
      minWidth: 80,
      field: "index",
      headerName: "Index",
    },
    {
      flex: 1,
      minWidth: 130,
      field: "title",
      headerName: "Feedback Type",
    },
    {
      flex: 1,
      minWidth: 150,
      field: "created_at",
      headerName: "Created Date",
      renderCell: ({ row }) => {
        const formatDate = moment(row.created_at).format("DD-MM-yyyy hh:mm A");
        return (
          <Typography sx={{ fontSize: "0.9rem !important" }}>
            {formatDate}
          </Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "action",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((permission.edit && role === "2") || role === "1") && (
                <IconButton onClick={() => handleEdit(row.id)}>
                  <PencilOutline fontSize="medium" />
                </IconButton>
              )}
              {((permission.delete && role === "2") || role === "1") && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize="medium" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },
    },
  ];

  const removeaction =
    !permission.edit && !permission.delete && role === "2"
      ? _.dropRight(columns)
      : columns;

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
  };

  const assemList = feedbackTypeList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      id: data.id,
      title: data.title,
      created_at: data.created_at,
    };
  });

  return (
    <Fragment>
      <Card sx={{ width: "100%", overflowInline: "hidden" }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          columns={removeaction}
          rows={assemList}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50]}
          components={{
            Toolbar: QuickSearchToolbar,
          }}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          pagination
          rowCount={Number(totalRecord)}
          page={pageNumber}
          paginationMode="server"
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              value: searchText,
              clearSearch: () => handleSearch(""),
              onChange: (event) => handleSearch(event.target.value),
              handleOpen: () => handleOpen("add", ""),
              title: isPermissionAllow(permission.edit, role)
                ? "Add Feedback Type"
                : "",
              isSearch: true,
              selectedRows: selectedRows,
              multiDelete: isPermissionAllow(permission.delete, role),
              onClickDelete: () => handleDeleteModal(),
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
        />
      </Card>

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows
            )
          }
        />
      )}
    </Fragment>
  );
};

export default FeedbackTypeList;
